import { useMemo } from 'react';

import {
    extractTrimmedValues,
    flattenDebriefSegments,
    pointsInRange,
} from 'ff/debrief/utils';
import { useDebriefRouter } from 'ff/debrief/hooks';
import {
    useGetDebriefByTrackUUIDQuery,
    useGetTracklogByIdQuery,
} from 'ff/debrief/features/TracklogApi';
import { SegmentWithPoints } from 'ff/debrief/models';

export const useDebriefSegments = () => {
    const router = useDebriefRouter();

    const selectedTracklogId = router.routeParams.tracklogId;

    const { data: debrief, ...debriefQueryStatus } =
        useGetDebriefByTrackUUIDQuery(selectedTracklogId, {
            skip: !selectedTracklogId,
        });

    const { data: tracklog, ...tracklogQueryStatus } = useGetTracklogByIdQuery(
        selectedTracklogId,
        {
            skip: !selectedTracklogId,
        }
    );

    const tracklogData = extractTrimmedValues(tracklog);

    const segmentsWithPoints: SegmentWithPoints[] = useMemo(() => {
        if (debriefQueryStatus.isSuccess && tracklogQueryStatus.isSuccess) {
            return flattenDebriefSegments(debrief.debriefSegments).map(
                segment => {
                    const start =
                        tracklogData.timestampStart +
                        segment.startOffsetInSeconds;
                    const end = start + segment.durationInSeconds;
                    return {
                        ...segment,
                        points: pointsInRange(tracklog.points.data, start, end),
                    };
                }
            );
        } else {
            return null;
        }
    }, [
        debriefQueryStatus.isSuccess,
        tracklogQueryStatus.isSuccess,
        debrief?.trackUuid,
        tracklog?.trackUuid,
    ]);

    return {
        segments: segmentsWithPoints,
    };
};
